<template>
	<div class="mb-8 flex items-center justify-between">
		<div class="flex items-center gap-2">
			<div class="mr-2 xl:hidden">
				<button
					class="focus:outline-hidden -ml-0.5 -mt-0.5 inline-flex h-12 w-12 items-center justify-center rounded-md text-gray-500 transition duration-150 ease-in-out hover:text-gray-900 focus:bg-gray-200"
					@click="$emit('open-sidebar')"
				>
					<IconMenu />
				</button>
			</div>

			<div class="sm:inline-flex">
				<!-- <button
				v-if="hasBack"
				class="inline-flex items-center justify-center mr-8 transition"
				@click="$router.back()"
			>
				<Icon name="carret-left" class="h-3 mr-2 fill-current" />Back
			</button> -->

				<div class="space-y-2">
					<h1 class="text-xl font-medium text-gray-900 sm:text-4xl">
						<span v-html="title" />
					</h1>

					<!-- <Breadcrumb v-if="breadcrumb" :breadcrumb="breadcrumb" /> -->
				</div>
			</div>
		</div>

		<UserAction />
	</div>
</template>

<script name="TheHeader" lang="ts" setup>
	import IconMenu from '~icons/fivb/menu';
	import UserAction from '@/ui/Layout/UserAction.vue';

	defineProps({
		title: {
			type: String,
			required: true,
		},

		breadcrumb: {
			type: Array,
			required: false,
			default: null,
		},
	});

	// const hasBack = computed(() => window.history.length > 2);
</script>
